import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "taskIds"]
  static values = { confirmMessage: String }

  submit(event) {
    if (!this.hasListTarget) {
      event.preventDefault()
      return
    }

    const taskElements = this.listTarget.querySelectorAll(':scope > [data-task-id]')
    const taskIds = Array.from(taskElements).map(el => el.dataset.taskId)

    if (taskIds.length === 0) {
      event.preventDefault()
      return
    }

    const message = this.confirmMessageValue.replace('%{count}', taskIds.length)
    if (!window.confirm(message)) {
      event.preventDefault()
      return
    }

    this.taskIdsTarget.value = taskIds.join(',')
  }
}
